/**
 * Generates hexadecimal SHA-1 hash of the data
 */
export const getHash = async (data: string) => {
  if (typeof window === 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return require('crypto').createHash('sha1').update(data).digest('hex');
  }

  const hash = await crypto.subtle.digest('SHA-1', new TextEncoder().encode(data));
  return arrayBuffer2hex(hash);
};

const arrayBuffer2hex = (buffer: ArrayBuffer) =>
  Array.from(new Uint8Array(buffer))
    .map((x) => x.toString(16).padStart(2, '0'))
    .join('');
